import { GraphQLQuery } from "@aws-amplify/api";
import uuid from "uuid/v4";

import { OpenGraphResponse, Resource } from "@examspark/types";

import { GraphQLAPI } from "../../client";
import { media } from "../../queries";
import { getPerformanceTaskStatic as getPerformanceTaskQueryGql } from "../../queries/media";
import { typedGql } from "../../utils";
import { createNumberedResource } from "../resource";

interface UploadProps {
  workspaceId: string;
  bankId: string;
  creatorId?: string;
}

export const createExternalLink = async (
  params: UploadProps & {
    link: {
      url: string;
      title?: string;
      description?: string;
      image?: string;
    };
  },
) => {
  const rsc: Resource = {
    id: uuid(),
    sk: "resource#v0",
    version: 0,
    schemaVersion: "2020-01-01",
    type: "EXTERNAL_LINK",
    name: params.link.title,
    workspaceId: params.workspaceId,
    bankId: params.bankId,
    creatorId: params.creatorId,
    data: JSON.stringify(params.link),
    isCreating: true,
  };

  const created = await createNumberedResource(rsc);
  return created.data?.createResource;
};

export const getOpenGraphMetadata = async (url: string) => {
  const response = (
    await GraphQLAPI.client.query<
      GraphQLQuery<{ getOpenGraphMetadata: string }>
    >({
      query: media.getOpenGraphMetadata,
      variables: {
        input: {
          action: "getOpenGraphMetadata",
          params: JSON.stringify({
            url,
          }),
        },
      },
    })
  ).data?.getOpenGraphMetadata;

  if (!response) {
    throw new Error("Failed to get OpenGraph metadata");
  }

  try {
    return JSON.parse(response) as OpenGraphResponse["hybridGraph"];
  } catch (error) {
    throw new Error("Failed to parse OpenGraph metadata");
  }
};

export const getPerformanceTask = async (assessmentId: string) => {
  return (
    await typedGql(getPerformanceTaskQueryGql)({
      input: {
        id: assessmentId,
        sk: "resource#v0",
      },
    })
  ).data?.getPerformanceTask;
};
